import React, { Component } from "react";
import ContentWrapper from "../../organisms/content-wrapper/index";
import { Card, CardBody, FormGroup, Button } from "reactstrap";
import PageLoader from "../../organisms/page-loader/index";
import SortableMaterial from "./sortable";
import MaterialComunicacaoAPI from "../../../services/apis/materialcomunicacao";
import CanalAPI from "../../../services/apis/canal";
import SingleSelect from "../../atoms/select-single";

class MaterialComunicacaoOrder extends Component {
  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(this.props.location.search);
    // const modoInicial =
    //   searchParams.get("modo") && searchParams.get("modo") === "canal"
    //     ? "canal"
    //     : "multi";

    this.state = {
      loading: false,
      lista: [],
      modo: "canal",
      canaisOptions: [],
      selectedCanalId: "",
    };
  }

  async componentDidMount() {
    const canaisOptions = (await CanalAPI.getSelectListAsync()) || [];
    const { modo } = this.state;

    if (modo === "canal") {
      const first = canaisOptions[0];
      const selectedCanalId = first ? first.options[0].value?.toString() : "";
      this.setState({ canaisOptions, selectedCanalId }, () => {
        if (selectedCanalId) {
          this.onChangeCanal();
        }
      });
    } else {
      this.setState({ canaisOptions });
      await this.getListAsync();
    }
  }

  setModoMulti = async () => {
    this.setState({ modo: "multi", selectedCanalId: "" });
    await this.getListAsync();
  };

  setModoCanal = () => {
    const { canaisOptions, selectedCanalId } = this.state;

    let canalId = selectedCanalId;
    if (!canalId && canaisOptions && canaisOptions.length > 0) {
      canalId = canaisOptions[0].value?.toString();
    }

    this.setState({ modo: "canal", selectedCanalId: canalId || "" }, () => {
      if (this.state.selectedCanalId) {
        this.onChangeCanal();
      }
    });
  };

  onChangeCanal = async () => {
    let { selectedCanalId, canaisOptions } = this.state;

    if (!selectedCanalId) {
      if (canaisOptions && canaisOptions.length > 0) {
        selectedCanalId = canaisOptions[0].value?.toString();
        this.setState({ selectedCanalId });
      } else {
        this.setState({ lista: [] });
        return;
      }
    }

    if (!selectedCanalId) return;

    this.setState({ loading: true });
    const result = await MaterialComunicacaoAPI.getListByCanal(
      parseInt(selectedCanalId, 10),
    );
    this.setState({ loading: false });
    if (result != null && result.data != null && result.data.value != null) {
      this.setState({ lista: result.data.value });
    } else {
      this.setState({ lista: [] });
    }
  };

  render() {
    const { modo, selectedCanalId, canaisOptions, lista, loading } = this.state;
    return (
      <ContentWrapper>
        <div className="content-heading">
          Materiais de Comunicação - Ordenar
        </div>
        {loading && <PageLoader />}
        <div className="row">
          <div className="col-md-12">
            <Card className="card-default">
              <CardBody>
                {modo === "canal" && (
                  <FormGroup>
                    <label className="col-form-label font-weight-bold">
                      Selecione o canal
                    </label>
                    <SingleSelect
                      parentObj={this}
                      selectList={canaisOptions}
                      stateProperty="selectedCanalId"
                      onChange={this.onChangeCanal}
                      isClearable={false}
                    />
                    {canaisOptions.length === 0 && (
                      <small className="form-text text-muted">
                        Nenhum canal cadastrado. Cadastre um canal para ordenar
                        por canal.
                      </small>
                    )}
                  </FormGroup>
                )}

                <form>
                  <FormGroup className="py-2">
                    <SortableMaterial
                      items={lista}
                      onSortItems={this.onSortItems}
                    />
                  </FormGroup>
                </form>
                <Button
                  className="btn btn-custom"
                  onClick={(e) => this.saveAsync(e)}
                  disabled={
                    loading ||
                    (modo === "canal" && !selectedCanalId) ||
                    lista.length === 0
                  }
                >
                  <i className={"fa fa-save"}></i> Salvar
                </Button>
                <hr></hr>
                <div className="row">
                  <div className="col-12">
                    <button
                      onClick={() => this.goBack()}
                      className="btn btn-link"
                    >
                      <i className="fas fa-arrow-left"> </i> Voltar
                    </button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </ContentWrapper>
    );
  }

  goBack = () => {
    this.props.history.goBack();
  };

  async saveAsync(e) {
    e.preventDefault();
    var lista = this.factoryOrdenadosFromState();

    if (lista === undefined) return;

    const { modo, selectedCanalId } = this.state;
    this.setState({ loading: true });

    let result;
    if (modo === "canal" && selectedCanalId) {
      const itens = lista.map((item, i) => ({
        materialComunicacaoId: item.materialComunicacaoId,
        ordem: i + 1,
      }));
      result = await MaterialComunicacaoAPI.updateOrderCanal({
        canalId: parseInt(selectedCanalId, 10),
        itens,
      });
    } else {
      result = await MaterialComunicacaoAPI.updateOrder(lista);
    }

    this.setState({ loading: false });

    if (
      result != undefined &&
      result.data != undefined &&
      result.data != null &&
      result.data.value != null
    ) {
      this.goBack();
    }
  }

  factoryOrdenadosFromState() {
    if (this.state.lista == undefined || this.state.lista.length <= 0)
      return undefined;

    let items = Object.assign([], this.state.lista);
    items.map((item, i) => {
      item.ordem = i + 1;
    });

    return items;
  }

  async getListAsync() {
    this.setState({ loading: true });
    var result = await MaterialComunicacaoAPI.getMaterialList();
    this.setState({ loading: false });

    if (
      result != undefined &&
      result.data != undefined &&
      result.data != null &&
      result.data.value != null
    ) {
      this.setState({
        lista: result.data.value,
      });
    }
  }

  onSortItems = (items) => {
    this.setState({
      lista: items,
    });
  };
}

export default MaterialComunicacaoOrder;
